import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchVendorsData = createAsyncThunk(
  "vendors/fetchRows",
  async ({ fromDate, toDate }, thunkAPI) => {
    try {
      const response = await api.get(
        `/api/VendorsLeadgersByDate?fromdate=${fromDate}&todate=${toDate}`
      );
      return { rows: response.data.users || [], fromDate, toDate };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const vendorsSlice = createSlice({
  name: "vendors",
  initialState: {
    data: [],
    filters: {},
    status: "idle",
    error: null,
  },
  reducers: {
    setFilters(state, action) {
      const { fromDate, toDate } = action.payload;
      state.filters = { fromDate, toDate };
    },
    resetData(state) {
      state.data = {};
      state.filters = {};
      state.status = {};
      state.error = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorsData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorsData.fulfilled, (state, action) => {
        const { fromDate, toDate, rows } = action.payload;
        state.data = rows;
        state.filters = { fromDate, toDate };
        state.status = "succeeded";
      })
      .addCase(fetchVendorsData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setFilters, resetData } = vendorsSlice.actions;

export const selectVendorsRows = (state) => state.vendors.data;
export const selectVendorsFilters = (state) => state.vendors.filters || {};
export const selectVendorsStatus = (state) => state.vendors.status || "idle";
export const selectVendorsError = (state) => state.vendors.error || null;

export default vendorsSlice.reducer;
